import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { gql, useQuery } from "@apollo/client";
import { Button, Input, Layout, PageHeader, Space, Table, Tooltip } from "antd";
import moment from "moment";
import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";

const measureSizesQuery = gql`
  query ($pagination: ConnectionPagination, $searchQuery: String) {
    measureSizes(pagination: $pagination, searchQuery: $searchQuery) {
      nodes {
        id
        code
        value
        insertedAt
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        page
        size
      }
      totalCount
      totalPages
    }
  }
`;

export const List: React.FC<{}> = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  const variables = {
    pagination: { page: 1, pageSize: 0 },
    orderBy: { direction: "ASC", field: "ID" },
    searchQuery,
  };
  const { loading, data } = useQuery(measureSizesQuery, { variables, fetchPolicy: "cache-and-network" });

  const handleSearch = (value: string) => setSearchQuery(value);
  const handleSearchCancel = () => setSearchQuery("");
  const handleTableChange = () => {};

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
    },
    {
      title: "Value",
      dataIndex: "value",
    },
    {
      title: "CreatedAt",
      render: (resource: any) => moment(resource.insertedAt).format("DD-MM-YYYY"),
    },
    {
      width: "80px",
      title: "Actions",
      dataIndex: "id",
      render: (id: string, resource: any) => (
        <Tooltip title="Edit">
          <Button onClick={() => navigate(`${id}/edit`)} icon={<EditOutlined />}></Button>
        </Tooltip>
      ),
    },
  ];

  return (
    <Fragment>
      <Layout.Header className="header-background">
        <Input.Search
          placeholder="search"
          onSearch={handleSearch}
          key={variables.searchQuery ?? "__search__"}
          defaultValue={variables.searchQuery ?? ""}
          style={{ width: 500, margin: "16px 30px" }}
        />
        <Button disabled={searchQuery.length === 0} onClick={handleSearchCancel} style={{ margin: "16px 0" }}>
          Cancel
        </Button>
      </Layout.Header>
      <Layout className="content">
        <PageHeader
          ghost={true}
          title="Sizes"
          extra={
            <Space size="large">
              <Button onClick={() => navigate("..")}>Back</Button>
              <Button
                onClick={() => {
                  navigate("new");
                }}
                type="primary"
              >
                <PlusOutlined />
                New
              </Button>
            </Space>
          }
        />
        <Layout.Content className="content">
          <Table
            rowKey="id"
            loading={loading}
            columns={columns}
            dataSource={data?.measureSizes.nodes}
            pagination={{
              hideOnSinglePage: true,
              showSizeChanger: true,
              showTotal: (total, range) => `Showing ${range} of ${total}`,
              total: data?.totalCount ?? 0,
            }}
            onChange={handleTableChange}
          />
        </Layout.Content>
      </Layout>
    </Fragment>
  );
};
